import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
    AppBar,
    Toolbar,
    Avatar,
    Box,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    makeStyles,
    CssBaseline,
    Drawer,
    Typography,
    createTheme,
    ThemeProvider,
    Collapse,
    Button
  } from "@material-ui/core";
  import {
    Apps,
    Menu,
    ContactMail,
    AssignmentInd,
    Home,
    Close,
    ListAlt,
    CheckCircle,
    ExpandLess,
    ExpandMore,
    ShoppingCart,
  } from "@material-ui/icons";
import logo from '../assets/logo.png'
import { auth } from "../firebase";
import { checkAuthState } from "../pages/authentication/auth-utils/auth-utils";

const useStyles = makeStyles((theme) => ({
    menuSliderContainer: {
      width: 250,
      // background: "#fbbbd3",
      height: "100%",
    },
    avatar: {
      margin: "0.25rem auto",
      padding: "0.5rem",
      width: theme.spacing(25),
      height: theme.spacing(25)
    },
    listItem: {
      color: "#111111",
    },
    itemPadding: {
      paddingLeft: 30
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
    },
    grow: {
      flexGrow: 1,
    },
}));

const darkTheme = createTheme({
  typography: {
    allVariants: {
      color: "#fcbbd3"
    },
  },
  palette: {
    //mode: 'dark',
    primary: {
      main: '#111111',
    },
  },
});
  
const listItemsAdmin = [
    // {
    //   listIcon: <Home />,
    //   listText: "Home",
    //   path: "/",
    // },
    {
      listIcon: <ListAlt />,
      listText: "Items",
      path: "/admin/items",
    },
    {
      listIcon: <Apps />,
      listText: "Item Types",
      path: "/admin/item-types",
    },
    {
      listIcon: <CheckCircle />,
      listText: "Item Status",
      path: "/admin/item-status",
    },
    {
      listIcon: <CheckCircle />,
      listText: "Item Categories",
      path: "/admin/item-categories",
    }
];

const listItemsSale = [
  {
    listIcon: <ListAlt />,
    listText: "Cosplay Essentials",
    path: "/app/for-sale/cosplay-essentials",
  },
  {
    listIcon: <ListAlt />,
    listText: "Wigs",
    path: "/app/for-sale/wigs",
  },
]

const listItemsRent = [
  {
    listIcon: <ListAlt />,
    listText: "Cosplay Sets",
    path: "/app/for-rent/cosplay-sets",
  },
  {
    listIcon: <ListAlt />,
    listText: "Wigs",
    path: "/app/for-rent/wigs",
  },
  {
    listIcon: <ListAlt />,
    listText: "Costumes",
    path: "/app/for-rent/costumes",
  },
  // {
  //   listIcon: <ListAlt />,
  //   listText: "Headwear",
  //   path: "/app/for-rent/headwear",
  // },
  // {
  //   listIcon: <ListAlt />,
  //   listText: "Footwear",
  //   path: "/app/for-rent/footwear",
  // },
]

const Navbar = () => {
    const classes = useStyles();
    const [hide, setHide]=useState(false)
    const [open, setOpen] = useState(false);
    const [expandAdmin, setExpandAdmin] = useState(false);
    const [expandSale, setExpandSale] = useState(false);
    const [expandRent, setExpandRent] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState(false);

    let path = useLocation();

    useEffect(() => {
      if (path.pathname === '/app/bids' || path.pathname === '/app/bids/:bid_id'){
        setHide(true)
      }
    }, [path])

    const toggleSlider = () => {
      setOpen(!open);
    };

    const handleExpandAdmin = () => {
      setExpandAdmin(!expandAdmin);
    };
    const handleExpandSale = () => {
      setExpandSale(!expandSale);
    };
    const handleExpandRent = () => {
      setExpandRent(!expandRent);
    };

    useEffect(() => {
      checkAuthState((isLoggedIn) => {
        setIsAuthorized(isLoggedIn);
      });
    }, []);

    const sideList = () => (
        <Box className={classes.menuSliderContainer} component="div">
          <Avatar
            className={classes.avatar}
            src={logo}
            alt="PeriCoCo"
          />
          {/* <IconButton onClick={toggleSlider}>
                <Close className={classes.listItem}/>
          </IconButton> */}
          <Divider />
          <List>
            <ListItem className={classes.listItem} button>
              
              <Link to="/" className={classes.listItem} onClick={toggleSlider}>
                <Typography className={classes.listItem}>
                  Home
                </Typography>
              </Link>
            </ListItem>
            {
              isAuthorized === true && (
                <>
                  <ListItem className={classes.listItem} button onClick={handleExpandAdmin}>
                    <Typography className={classes.listItem}>
                      Admin
                    </Typography>
                    <ListItemText />
                    {expandAdmin ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={expandAdmin} timeout="auto" unmountOnExit>
                    <List component="div">
                      {listItemsAdmin.map((listItem, index) => (
                        <ListItem className={classes.itemPadding} button key={index}>
                          <ListItemIcon className={classes.listItem}>
                            {listItem.listIcon}
                          </ListItemIcon>
                          <Link to={listItem.path} className={classes.listItem} onClick={toggleSlider}>
                              <span>{listItem.listText}</span>
                          </Link>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </>
              )
            }
            <ListItem className={classes.listItem} button onClick={handleExpandSale}>
              <Typography className={classes.listItem}>
                For Sale
              </Typography>
              <ListItemText />
              {expandSale ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={expandSale} timeout="auto" unmountOnExit>
              <List component="div">
                {listItemsSale.map((listItem, index) => (
                  <ListItem className={classes.itemPadding} button key={index}>
                    <ListItemIcon className={classes.listItem}>
                      {listItem.listIcon}
                    </ListItemIcon>
                    <Link to={listItem.path} className={classes.listItem} onClick={toggleSlider}>
                        <span>{listItem.listText}</span>
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Collapse>
            <ListItem className={classes.listItem} button onClick={handleExpandRent}>
              <Typography className={classes.listItem}>
                For Rent
              </Typography>
              <ListItemText />
              {expandRent ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={expandRent} timeout="auto" unmountOnExit>
              <List component="div">
                {listItemsRent.map((listItem, index) => (
                  <ListItem className={classes.itemPadding} button key={index}>
                    <ListItemIcon className={classes.listItem}>
                      {listItem.listIcon}
                    </ListItemIcon>
                    <Link to={listItem.path} className={classes.listItem} onClick={toggleSlider}>
                        <span>{listItem.listText}</span>
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </List>
        </Box>
    );  
    
    // const handleRent = async () => {
    //   try {
    //     navigate('/app/request-rent/agreement');
    //   } catch (error) {
    //     console.error('handleRent error:', error);
    //   }
    // };

    const handleLogout = async () => {
      try {
        await auth.signOut();
        // Optional: Perform any additional actions after logout
        // For example, clear user data from state or local storage
      } catch (error) {
        console.error('Logout error:', error);
      }
    };

    return (
        <>
            <CssBaseline />

            <Box component="nav">
            <ThemeProvider theme={darkTheme}>
              <AppBar position="static" color="primary">
                <Toolbar>
                {
                  hide === false && (
                    <IconButton onClick={toggleSlider} color="inherit">
                      <Menu />
                    </IconButton>
                  )
                }
                {/* <IconButton onClick={toggleSlider} color="inherit">
                    <Menu />
                </IconButton> */}
                {
                  hide === false ? (
                    <Typography>Peridot's Cosplay Collections</Typography>
                  ) : (
                    <Typography>Peridot's Auction House</Typography>
                  )
                }
                {/* <Typography>Peridot's Cosplay Collections</Typography> */}
                <div className={classes.grow} />
                {
                  hide === false && (
                    isAuthorized === true && (
                      <Button onClick={handleLogout} color="inherit">
                        Logout
                      </Button>
                    )
                  )
                }
                {/* {isAuthorized === true && (
                <Button onClick={handleRent} color="inherit" variant="outlined">
                  Rent
                </Button>
                <IconButton color="inherit">
                  <ShoppingCart />
                </IconButton>
                {isAuthorized === true && (
                  <Button onClick={handleLogout} color="inherit">
                    Logout
                  </Button>
                )} */}
                {
                  hide === false && (
                    <Drawer open={open} anchor="left" onClose={toggleSlider}>
                      {sideList()}
                    </Drawer>
                  )
                }
                {/* <Drawer open={open} anchor="left" onClose={toggleSlider}>
                    {sideList()}
                </Drawer> */}
                </Toolbar>
              </AppBar>
            </ThemeProvider>
            </Box>
        </>
    )
};

const SidebarData = [
    {
        _id: 0,
        title: "Home",
        path: "/",
    },
    {
        _id: 1,
        title: "Items",
        path: "/items",
    },
    {
        _id: 2,
        title: "Item Types",
        path: "/item-types",
    },
    {
        _id: 3,
        title: "Item Status",
        path: "/item-status",
    }
];

export default Navbar;